export const langOps = [
  {
    ko: "KOR",
    en: "KOR",
    value: "ko",
    code: "ko",
  },
  {
    ko: "EN",
    en: "EN",
    value: "en",
    code: "en",
  },
  // {
  //   ko: "JA",
  //   en: "JA",
  //   value: "ja",
  //   code: "ja",
  // },
];

export const dayOption = [
  {
    ko: "일",
    value: "0",
    en: "Sun",
  },
  {
    ko: "월",
    value: "1",
    en: "Mon",
  },
  {
    ko: "화",
    value: "2",
    en: "Tue",
  },
  {
    ko: "수",
    value: "3",
    en: "Wed",
  },
  {
    ko: "목",
    value: "4",
    en: "Thu",
  },
  {
    ko: "금",
    value: "5",
    en: "Fri",
  },
  {
    ko: "토",
    value: "6",
    en: "Sat",
  },
];

export const monthOption = [
  { ko: "월", value: "", en: "Month" },
  {
    ko: "1월",
    value: "1",
    // en: "1",
    en: "Jan.",
  },
  {
    ko: "2월",
    value: "2",
    // en: "2",
    en: "Feb.",
  },
  {
    ko: "3월",
    value: "3",
    // en: "3",
    en: "Mar.",
  },
  {
    ko: "4월",
    value: "4",
    // en: "4",
    en: "Apr.",
  },
  {
    ko: "5월",
    value: "5",
    // en: "5",
    en: "May.",
  },
  {
    ko: "6월",
    value: "6",
    // en: "6",
    en: "Jun.",
  },
  {
    ko: "7월",
    value: "7",
    // en: "7",
    en: "Jul.",
  },
  {
    ko: "8월",
    value: "8",
    // en: "8",
    en: "Aug.",
  },
  {
    ko: "9월",
    value: "9",
    // en: "9",
    en: "Sep.",
  },
  {
    ko: "10월",
    value: "10",
    // en: "10",
    en: "Oct.",
  },
  {
    ko: "11월",
    value: "11",
    // en: "11",
    en: "Nov.",
  },
  {
    ko: "12월",
    value: "12",
    // en: "12",
    en: "Dec.",
  },
];

export const monthOptionNm = [
  // { ko: "월", value: "", en: "Month" },
  {
    ko: "1월",
    en: "1",
    value: "1",
    code: "01",
    // en: "Jan.",
  },
  {
    ko: "2월",
    en: "2",
    value: "2",
    code: "02",
    // en: "Feb.",
  },
  {
    ko: "3월",
    en: "3",
    value: "3",
    code: "03",
    // en: "Mar.",
  },
  {
    ko: "4월",
    en: "4",
    value: "4",
    code: "04",
    // en: "Apr.",
  },
  {
    ko: "5월",
    en: "5",
    value: "5",
    code: "05",
    // en: "May.",
  },
  {
    ko: "6월",
    value: "6",
    en: "6",
    code: "06",
    // en: "Jun.",
  },
  {
    ko: "7월",
    en: "7",
    value: "7",
    code: "07",

    // en: "Jul.",
  },
  {
    ko: "8월",
    en: "8",
    value: "8",
    code: "08",
    // en: "Aug.",
  },
  {
    ko: "9월",
    en: "9",
    value: "9",
    code: "09",

    // en: "Sep.",
  },
  {
    ko: "10월",
    en: "10",
    value: "10",
    code: "10",
    // en: "Oct.",
  },
  {
    ko: "11월",
    en: "11",
    value: "11",
    code: "11",
    // en: "Nov.",
  },
  {
    ko: "12월",
    en: "12",
    value: "12",
    code: "12",

    // en: "Dec.",
  },
];

export const mailOption = [
  { ko: "직접 입력", value: "", en: "Select Email" },
  { ko: "naver.com", code: "naver.com", en: "naver.com" },
  { ko: "gmail.com", code: "gmail.com", en: "gmail.com" },
  { ko: "goole.com", code: "goole.com", en: "goole.com" },
  { ko: "hotmail.com", code: "hotmail.com", en: "hotmail.com" },
  { ko: "hanmail.net", code: "hanmail.net", en: "hanmail.net" },
  { ko: "yahoo.com", code: "yahoo.com", en: "yahoo.com" },
  { ko: "yahoo.co.ko", code: "yahoo.co.ko", en: "yahoo.co.ko" },
];
